import { BOARD_COLUMN_RESIZE_MIN_WIDTH } from "@common/kanban/kanbanUtils";
import { useCallback, useState } from "react";

export const useColumnWidths = () => {
  const [columnWidths, setColumnWidths] = useState({});
  const handleColumnResizeStart = useCallback(
    (event, leftStatus, rightStatus) => {
      event.preventDefault();
      event.stopPropagation();

      const divider = event.currentTarget;
      const leftColumn = divider.previousElementSibling;
      const rightColumn = divider.nextElementSibling;

      if (!leftColumn || !rightColumn) return;

      const startX = event.clientX;
      const leftStartWidth = leftColumn.getBoundingClientRect().width;
      const rightStartWidth = rightColumn.getBoundingClientRect().width;
      const totalWidth = leftStartWidth + rightStartWidth;
      const minWidth = Math.min(
        BOARD_COLUMN_RESIZE_MIN_WIDTH,
        Math.floor(totalWidth / 2),
      );

      const handleMouseMove = (moveEvent) => {
        const delta = moveEvent.clientX - startX;
        const nextLeftWidth = Math.max(
          minWidth,
          Math.min(totalWidth - minWidth, leftStartWidth + delta),
        );
        const nextRightWidth = totalWidth - nextLeftWidth;

        setColumnWidths((prev) => ({
          ...prev,
          [leftStatus]: nextLeftWidth,
          [rightStatus]: nextRightWidth,
        }));
      };

      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    },
    [],
  );

  return { columnWidths, handleColumnResizeStart, setColumnWidths };
};
